import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import StaticNav from './StaticNav';

const PoliciesNav =  React.memo(function MemoPoliciesList(){

    const data = useStaticQuery(graphql`
        query {
            allAsciidoc(filter: { frontmatter: { layout: {eq: "policy"}, skip: {ne: "all"} } }) {
                edges {
                    node {
                    frontmatter {
                        title
                        skipBefore
                        skipAfter
                        permalink
                        order
                        skip
                        topindex
                    }
                    paths {
                        from {
                        source {
                            file
                        }
                        }
                    }
                    }
                }
            }
        }
    `);

    return ( 
        <StaticNav 
            data={data}
            pathBase="policies"
        />
  );
})


export default PoliciesNav;
